module.exports = __webpack_public_path__ + "static/media/flag_spain.149bc940.png";